import { connect } from 'react-redux';

import withDeleteModal from '../hoc/withDeleteModal';

import { removePost } from 'api/brands/deletePost';
import { companyAdminDeletePost } from 'actions/company-admin';
import { deletePost } from 'actions/posts';

const mapStateToProps = state => {
  return {};
};

const mapDispatchToProps = dispatch => {
  return {
    // Update both slices on a successful delete:
    //   - state.post.posts (state.post): personal-area kanban / list /
    //     social-view all read from here — without this dispatch the
    //     deleted post lingered in the UI until a full reload.
    //   - state.companyAdmin.brands[].posts: the super-admin view
    //     watches that slice and continues to need the same signal.
    reduxRemover: postId => {
      dispatch(deletePost(postId));
      dispatch(companyAdminDeletePost(postId));
    },
  };
};

const DeletePostModal = withDeleteModal({
  itemLabel: 'post',
  request: removePost,
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(DeletePostModal);
